import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {NewBaseResponseInterface} from "@/common/Http/Interfaces/NewBaseResponseInterface";

const restApiConfig = new RESTAPIConfig();

interface CreateMeaningToExtensionsPayloadInterface {
    id: string,
    extensions: string[],
}

export const CreateMeaningsToExtensionsApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        createMeaningsToExtensions: builder.mutation<NewBaseResponseInterface<unknown, unknown>, CreateMeaningToExtensionsPayloadInterface>({
            query: (body) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileMeaningsToExtensions(),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error) => {
                if (!error) {
                    return ["FileMeaningsToExtensions"];
                }
                return [];
            }
        })
    })
});

export const {useCreateMeaningsToExtensionsMutation} = CreateMeaningsToExtensionsApiSlice;
